import React, { type FC } from 'react'

import {
  Flex,
  GRID_VARIANT_SMALL,
  Grid,
  GridCell,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
} from 'mailup-web-components'

const ResultSkel: FC = () => {
  return (
    <Grid cols={12} variant={GRID_VARIANT_SMALL}>
      <GridCell span={3}>
        <Flex flexDirection="column" gap="4px">
          <SkeletonLoader
            variant={SKELETON_LOADER_VARIANT_ONWHITE}
            height="15px"
            margin="0 0 5px 0"
          />
          <SkeletonLoader
            variant={SKELETON_LOADER_VARIANT_ONWHITE}
            height="14px"
            margin="0 0 3.5px 0"
          />
        </Flex>
      </GridCell>
      <GridCell span={3}>
        <Flex flexDirection="column" gap="4px">
          <SkeletonLoader
            variant={SKELETON_LOADER_VARIANT_ONWHITE}
            height="15px"
            margin="0 0 5px 0"
          />
          <SkeletonLoader
            variant={SKELETON_LOADER_VARIANT_ONWHITE}
            height="14px"
            margin="0 0 3.5px 0"
          />
        </Flex>
      </GridCell>
      <GridCell span={2}>
        <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
      </GridCell>
      <GridCell span={2}>
        <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
      </GridCell>
      <GridCell span={2}>
        <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
      </GridCell>
    </Grid>
  )
}

export default ResultSkel
